import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Login from "../../Pages/Login/Login";

const Dashboard = ({ AnotherComponent }) => {
  const profile = JSON.parse(localStorage.getItem("admin-profile"));

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin-token");
    localStorage.removeItem("admin-profile");
    navigate("/admin/login");
    toast.success("Admin Logged Out Successfully");
  };
  return (
    <>
      {profile !== null ? (
        <div className="flex bg-white">
          <div className="md:flex w-2/5 md:w-1/4 h-screen bg-white border-r hidden">
            <div className="mx-auto py-10">
              <h1 className="text-2xl font-bold mb-10 cursor-pointer text-[#EC5252] duration-150">
                DLX
              </h1>
              <ul>
                <Link to="/">
                  <li className="flex space-x-2 mt-10 cursor-pointer hover:text-[#EC5252] duration-150">
                    <i className="fa-solid fa-house-user"></i>
                    <span className="font-semibold">Home</span>
                  </li>
                </Link>
                <Link to="/admin/all-users">
                  <li className="flex space-x-2 mt-10 cursor-pointer hover:text-[#EC5252] duration-150">
                    <i className="fa-solid fa-users "></i>
                    <span className="font-semibold">All Users</span>
                  </li>
                </Link>
                <Link to="/admin/all-products">
                  <li className="flex space-x-2 mt-10 cursor-pointer hover:text-[#EC5252] duration-150">
                    <i className="fa-brands fa-product-hunt "></i>
                    <span className="font-semibold">All Products</span>
                  </li>
                </Link>
                <Link to="/admin/all-blogs">
                  <li className="flex space-x-2 mt-10 cursor-pointer hover:text-[#EC5252] duration-150">
                    <i className="fa-solid fa-blog"></i>
                    <span className="font-semibold">All Blogs</span>
                  </li>
                </Link>
                <Link to="/admin/all-labtests">
                  <li className="flex space-x-2 mt-10 cursor-pointer hover:text-[#EC5252] duration-150">
                    <i className="fa-solid fa-flask"></i>
                    <span className="font-semibold">All Labtests</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <main className="min-h-screen w-full bg-white border-l">
            <nav className="flex items-center justify-between px-10 bg-white py-6 border-b">
              <div className="flex items-center bg-gray-100 px-4 py-2 rounded-md space-x-3 w-96">
                <input
                  type="text"
                  placeholder="search"
                  className="bg-gray-100 outline-none w-full"
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 cursor-pointer text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <div className="flex items-center hover:cursor-pointer space-x-4">
                <Link to="/admin/profile">
                  <img
                    className="w-8 rounded-full"
                    src={profile.avatar}
                    alt="Elon Musk"
                  />
                </Link>
                <p
                  className="bg-red-700 text-gray-300 hover:bg-red-800 hover:text-white
                          px-3 py-2 rounded-md text-sm font-medium ml-5 hover:cursor-pointer"
                  onClick={handleLogout}
                >
                  Logout
                </p>
              </div>
            </nav>
            <div className="container">{AnotherComponent}</div>

            <footer className="text-center py-6 mt-4">
              Copyright &copy; 2022 | Drug-Loft-Xpress
            </footer>
          </main>
        </div>
      ) : (
        <Login />
      )}
    </>
  );
};

export default Dashboard;
